/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".greyed-out[_ngcontent-%COMP%]{opacity:.4;filter:alpha(opacity=40)}"];
export { styles as styles };
